<template>
  <div class="bjy-playback-player">
    <video id="bjy-player-teacher" src=""></video>
  </div>
</template>

<script>
const store = BJY.store
let player = null
export default {
  props: ['videoInfo'],
  components: {},
  data() {
    return {
      videoEl: null,
    }
  },
  methods: {
    play() {
      this.videoEl.play()
    },
    pause() {
      this.videoEl.pause()
    },
    togglePlay() {
      this.videoEl.paused ? this.videoEl.play() : this.videoEl.pause()
    },
    setVolume(value) {
      this.videoEl.volume = value
    },
    playBySeconds(num) {
      if (num && document.getElementById('bjy-player-teacher')) {
        var myVideo = document.getElementById('bjy-player-teacher')
        myVideo.play()
        myVideo.currentTime = num
      }
    },
    loadVideo(quality) {
      const data = this.videoInfo
      if (data && data.videos) {
        quality = quality || data.defaultDefinition
        let url = data.videos[quality][0].url
        url = url.replace('https:', '').replace('http:', '')

        if (url.indexOf('ev1') > -1 && window.flvjs) {
          // 使用flvjs 播放加密格式视频
          // 如果已经存在拉流则先销毁原流
          if (player) {
            player.destroy()
          }
          player = window.flvjs.createPlayer(
            {
              type: 'ev1',
              url: url,
              cors: true,
            },
            {
              stashInitialSize: 1024,
            }
          )
          player.attachMediaElement(this.videoEl)
          player.load()
        } else {
          this.videoEl.src = url
        }
        store.set('isPlaying', false)
        this.$nextTick(() => {
          // this.videoEl.play()
          this.playBySeconds(this.videoInfo.lastWatchTime)
        })
      } else {
        alert('获取回放视频信息失败!')
      }
    },
    swap(presenterCameraNode, whiteboardNode) {
      var presenterCameraParentNode = presenterCameraNode.parentNode
      var whiteboardParentNode = whiteboardNode.parentNode
      var presenterCameraPlaceholder = document.createElement('div')
      var whiteboardPlaceholder = document.createElement('div')

      presenterCameraParentNode.insertBefore(
        presenterCameraPlaceholder,
        presenterCameraNode
      )
      whiteboardParentNode.insertBefore(whiteboardPlaceholder, whiteboardNode)

      whiteboardNode &&
        presenterCameraParentNode.insertBefore(
          whiteboardNode,
          presenterCameraPlaceholder
        )
      presenterCameraNode &&
        whiteboardParentNode.insertBefore(presenterCameraNode, whiteboardPlaceholder)

      presenterCameraParentNode.removeChild(presenterCameraPlaceholder)
      whiteboardParentNode.removeChild(whiteboardPlaceholder)
    },

    // 切换ppt与主讲视频位置，如需同步切换，可通过自定义信令实现
    pptVideoSwitch() {
      const presenterDom = $('.player-panel')[0]
      const whiteboardDom = $('.bjy-whiteboard')[0]
      console.log('1111', presenterDom, whiteboardDom)
      // this.changePosition(presenterDom, whiteboardDom)
      this.swap(presenterDom, whiteboardDom)
      // eventEmitter.trigger(eventEmitter.WINDOW_RESIZE)
    },
  },
  mounted() {
    const videoEl = this.videoEl = document.getElementById('bjy-player-teacher')
    store.set('teacherVideo', videoEl)
    store.set('isPlaying', false)
    const data = this.videoInfo
    const that = this
    this.loadVideo()
    if (data.scene === 'video') {
      this.pptVideoSwitch()
      $('.bjy-playback-player video').css({ 'height': 'calc(100vh - 100px)' })
      $('.bjy-playback-message-list-wrap').css({ 'background-color': '#fff' })
    }
    // 播放器初始化完成之后在这里实现记忆播放之类的逻辑
    BJY.playback.start(0)
    videoEl.onplay = function () {
      BJY.playback.play()
      store.set('isPlaying', true)
    }

    videoEl.onpause = function () {
      BJY.playback.pause()
      store.set('isPlaying', false)
    }

    // 影响白板和回放的同步
    videoEl.onseeked = function () {
      BJY.playback.seek(videoEl.currentTime)
      BJY.playback.play()
    }

    /**
     * 必须监听视频的timeupdate事件，来告诉回放去根据视频时间更新数据
     * 注意：不要使用videoEl.ontimeupdate的方式来设置监听，可能会被其他地方覆盖，使得无法同步信令
     */
    videoEl.addEventListener('timeupdate', function () {
      BJY.playback.timeupdate(videoEl.currentTime)
    })

    // 视频加载后会触发durationchange事件，此时再去创建playerslider组件(playerslider需要duration参数)
    videoEl.ondurationchange = () => {
      //  BJY.playback.seek('300')
      //  that.play()
      this.$emit('getDuration')
    }
    this.$nextTick(() => {
      that.play()
    })
  },
  beforeDestroy() { },
}
</script>

<style lang="scss" scoped>
//@import url(); 引入公共css类
.bjy-playback-player {
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
  }
}
</style>
